import { createSlice } from '@reduxjs/toolkit'
import { fetchOrderByNumber, submitOrder, cancelProduct, fetchOrderById } from '../thunk/orderThunk'

const initialState = {
    // status
    isLoading: false,
    error: null,

    // data
    completeOrder: null,
    searchedOrder: null,
}

export const orderSlice = createSlice({
    name: 'order',
    initialState,
    reducers: {
        setCompleteOrder: (state, action) => {
            state.completeOrder = action.payload
        },
        setSearchedOrder: (state, action) => {
            state.searchedOrder = action.payload
        },
        updateOrderPaid: (state, action) => {
            const paidOrder = action.payload

            if (!state.searchedOrder) return
            state.searchedOrder = {
                ...state.searchedOrder,
                ...paidOrder,
            }
        },
        updateCompletedDish: (state, action) => {
            const { dish } = action.payload

            const dishes = state.searchedOrder.dishes.map(item => {
                if (item.id === dish.id) {
                    item.variants.find(v => v.variantId === dish.variantId).completedAt = dish.completedAt
                }
                return item
            })

            state.searchedOrder = {
                ...state.searchedOrder,
                dishes,
            }
        },
    },
    extraReducers: builder => {
        builder
            /** fetchOrderByNumber */
            .addCase(fetchOrderByNumber.pending, state => {
                state.isLoading = true
                state.error = null
            })
            .addCase(fetchOrderByNumber.fulfilled, (state, action) => {
                state.isLoading = false
                state.searchedOrder = action.payload
            })
            .addCase(fetchOrderByNumber.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.payload
            })
            /** submitOrder */
            .addCase(submitOrder.pending, state => {
                state.isLoading = true
                state.error = null
            })
            .addCase(submitOrder.fulfilled, (state, action) => {
                state.isLoading = false
                state.completeOrder = action.payload
            })
            .addCase(submitOrder.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.payload
            })
            /** cancelProduct */
            .addCase(cancelProduct.pending, state => {
                state.isLoading = true
                state.error = null
            })
            .addCase(cancelProduct.fulfilled, (state, action) => {
                // const { result, productId } = action.payload

                state.isLoading = false
            })
            .addCase(cancelProduct.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.payload
            })
            /** fetchOrderById */
            .addCase(fetchOrderById.pending, state => {
                state.isLoading = true
                state.error = null
            })
            .addCase(fetchOrderById.fulfilled, (state, action) => {
                state.isLoading = false
                state.completeOrder = action.payload
            })
            .addCase(fetchOrderById.rejected, state => {
                state.isLoading = false
            })
    },
})

export const orderActions = {
    ...orderSlice.actions,
    fetchOrderByNumber,
    submitOrder,
    cancelProduct,
    fetchOrderById,
}

export default orderSlice.reducer
